<template>
  <component
    :is="tag"
    @click="$emit('click', $event)"
  >
    <slot />
  </component>
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'BaseButton',

    props: {
      tag: {
        type: String,
        default: 'button',
      },
    },

    emits: ['click'],
  });
</script>
